import {
  useGetAgentInfoAgentInfoGetQuery,
  useGetChannelInfoChannelInfoGetQuery,
} from '@shared/api';
import { useMemo } from 'react';
import type { SelectOption } from '../lib/types';

export const useAgentFieldOptions = (channelId?: number) => {
  const { data: channelInfo } = useGetChannelInfoChannelInfoGetQuery(
    { channelId: channelId as number },
    { skip: !channelId },
  );

  const agentId = channelInfo?.agent_id;
  const { data: agentInfo } = useGetAgentInfoAgentInfoGetQuery(
    { agentId: agentId as number },
    { skip: !agentId },
  );

  const options: SelectOption[] = useMemo(
    () =>
      (agentInfo?.agent_fields ?? []).map((field) => ({
        value: field.id,
        label: field.name,
      })),
    [agentInfo?.agent_fields],
  );

  return { options };
};
